
import React from 'react';
import { observer } from 'mobx-react';
import dateFormat from 'dateformat';
//import FormControls from './controls/FormControls';
import SimpleInput from './inputs/SimpleInput';
import SimpleTextarea from './inputs/SimpleTextarea';
import ReactSingleSelect from './inputs/ReactSingleSelect';
//import ReactMultiSelect from './inputs/ReactMultiSelect';
import ReactMultiSelectCluster from './inputs/ReactMultiSelectCluster';
import ReactSelectPostType from './inputs/ReactSelectPostType';
import WidgetDateTimePicker from './inputs/WidgetDateTimePicker';
//import { stores, clusterStore } from "../../models/index";

import 'react-select/dist/react-select.css';
import '../../assets/styles/PostForm.css'

export default observer(({ form }) => {    
    let incidentOrMaintenance = form.$('type').value.value === "incident" || form.$('type').value.value === 'maintenance';    
    return (
        form.display ?
            <form className="form-post" onSubmit={form.onSubmit}>
                <div className="post-sublist-date">{dateFormat(new Date(), "mmm dd, yyyy")}</div>
                <div className="form-row">
                    <div className="post-type-field"><ReactSelectPostType field={form.$('type')} /></div>
                    <div className="post-title-field"><SimpleInput field={form.$('title')} /></div>
                    <div className="post-status-field"><ReactSingleSelect field={form.$('status')} /></div>
                </div>
                <div className="form-row type">                    
                    {incidentOrMaintenance
                        ? <div>
                            <SimpleTextarea field={form.$("firstUpdate")} rows="7" />
                            <ReactSingleSelect field={form.$('statusUpdate')} />
                          </div>
                        : <SimpleTextarea field={form.$("description")} rows="7" />}
                </div>
                <div className="form-row clusters">
                    <ReactMultiSelectCluster field={form.$('clusters')} />
                </div>
                <div className="form-row">
                    <WidgetDateTimePicker field={form.$('expiry')} />
                </div>

                <div className="form-controls">
                    <button
                        type="submit"
                        className="form-control-save"
                        onClick={form.onSubmit}
                    >{(form.submitting || form.validating)
                        ? <span className="fa-spinner fa-spin" />
                        : <span> Post</span>}</button>
                    <button
                        className="form-control-reset"
                        onClick={(...args) => {
                            form.onReset(...args);
                            form.display = false;
                        }}
                    ><span>Cancel</span></button>
                    <div className="form-error">
                        {form.error}
                    </div>

                </div>

                <p>{form.error}</p>
            </form> : ""
    )
});




// WEBPACK FOOTER //
// ./src/components/forms/FormPost.jsx